"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../../hooks");
const molecules_1 = require("../../molecules");
function BottomPanelMobile({ menuVisible, onHideMenuButtonClick, }) {
    const isModelPlaced = (0, hooks_1.useIsModelPlaced)();
    const isScaleAvailable = (0, hooks_1.useIsScaleAvailable)();
    const [sliderActive, setSliderActive] = (0, react_1.useState)(false);
    const isSliderActive = isModelPlaced && isScaleAvailable && sliderActive;
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: menuVisible, timeout: 200, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'BottomPanelMobile_CSSTransition', children: (0, jsx_runtime_1.jsx)(BottomPanel, { "data-e2e": 'BottomPanelMobile_BottomPanel', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.SwitchTransition, { mode: "out-in", "data-e2e": 'BottomPanelMobile_SwitchTransition', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: true, timeout: 200, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'BottomPanelMobile_CSSTransition', children: isSliderActive ? ((0, jsx_runtime_1.jsx)(molecules_1.SliderPanelMobile, { onHideSliderButtonClick: () => setSliderActive(false), "data-e2e": 'BottomPanelMobile_SliderPanelMobile' })) : ((0, jsx_runtime_1.jsx)(molecules_1.ButtonsPanelMobile, { onShowSliderButtonClick: () => setSliderActive(true), onHideMenuButtonClick: onHideMenuButtonClick, "data-e2e": 'BottomPanelMobile_ButtonsPanelMobile' })) }, String(isSliderActive)) }) }) }));
}
exports.default = BottomPanelMobile;
const BottomPanel = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: center;

  width: 100%;
  height: 80px;

  background-color: ${props => props.theme.black_50};

  &.enter {
    transform: translateY(100%);
    opacity: 0;
  }

  &.enter-active {
    transform: initial;
    opacity: 1;

    transition: all 0.15s ease-in-out;
  }

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    transform: translateY(100%);
    opacity: 0;

    transition: all 0.15s ease-in-out;
  }
`;
